import { Box, Typography } from '@mui/material';
import React from 'react';
import { ScanStatus } from '../../../type';

type RemoteRawFileMessageProps = {
  icon: React.ReactNode;
  fileName?: string;
  scanStatus?: ScanStatus;
};

export const RemoteRawFileMessage = (props: RemoteRawFileMessageProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {props.icon}
      <Typography
        sx={{
          fontSize: 14,
          pl: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {props.fileName}
      </Typography>
    </Box>
  );
};
